import SessionStorageService from "../services/SessionStorageService";
import { FormSectionElements, FormSections, FormSubSections, FunctionDetail, ProgramContainer } from "../entities/formTemplateDataType";
import Utils from "./Utils";
import DataUtils from "./DataUtils";
import axios from "axios";
import URLUtils from "./URLUtils";
import { FormEntity } from "../entities/FormEntity";
import * as CircularJSON from 'circular-json';
import { TOKEN_TYPE } from "../entities/Constants";

export default class CMAUtils {
    static generateCMASection = (programContainer: ProgramContainer) => {
        // const currentUser = SessionStorageService.getUserId()?.toLowerCase();
        // console.log(currentUser)
        // const orgs = programContainer.OrganizationList?.filter(o => o.Lead1.Email?.toLowerCase() == currentUser || o.Lead2.Email?.toLowerCase() == currentUser);
        // if (!orgs?.length) return null;

        const reviewPageIndex = 3;
        const dashboardIndex = 2;

        // let currenOrganization = orgs[0];
        // const selectedTemplates = currenOrganization.Templates?.filter(p=>p.Name=programContainer.Template);
        // console.log(currenOrganization)
        // const selectedTemplates = currenOrganization.Templates?.filter(p => p == programContainer.Template);
        // let selectedTemplate
        // if (selectedTemplates?.length > 0) {
            // selectedTemplate = selectedTemplates[0];
        // }

        const listSection = programContainer.ListOfFormSections.filter(p => !p.Dynamic);
        listSection[dashboardIndex].ENUDescription = programContainer.organizationName;
        listSection[reviewPageIndex].ENUDescription = programContainer.organizationName

        let functions = programContainer.CMATemplateList.filter(t => t.Name == programContainer.Template)[0].Functions;
     
        functions = functions?.map(f => {
            const filteredFunc = new FunctionDetail();
            filteredFunc.FunctionName = f.FunctionName;
            filteredFunc.CategoryDetailList = f.CategoryDetailList.filter(c => Utils.isNotNullOrEmpty(c.SubcategoryNameList));
            filteredFunc.CategoryNameList = filteredFunc.CategoryDetailList.map(c => c.CategoryName);
            return filteredFunc;
        });

        functions = functions?.filter(f => f.CategoryDetailList.length != 0);

        programContainer.ListOfFormSections = [];
        programContainer.ListOfFormSections.push(...listSection);
 
        functions?.forEach((f, findex) => {
            f.CategoryDetailList.forEach((c, index) => {
                let newSection = new FormSections();
                newSection.ENUTitle = "Category " + String(index + 1) + ": " + c.CategoryName;
                newSection.ENUDescription = `Function ${findex + 1}: ${f.FunctionName}`;
                let subsec = new FormSubSections();
                subsec.ListOfFormSectionElements = [];
                subsec.Sequence = 1;
                subsec.Visible = true;
                subsec.parent = newSection;
                c.SubcategoryNameList.forEach((subName) => {
                    const subcatObj = programContainer.SubCategoryNameList.filter((s) => s.code == subName)[0];
                    let ele = new FormSectionElements();
                    ele.Datatype = "CMAQuestion";
                    ele.LoadBindName = subName;
                    ele.Id = f.FunctionName + index + subName;
                    ele.Visible = true;
                    ele.Editable = 'Y';
                    ele.ENUTitle = subcatObj.description;
                    ele.hintExpansionTitle = "Implementation guidelines";
                    ele.callOutBoxType = "richText";
                    ele.callOutBoxBody = subcatObj.callOutBoxBody;
                    ele.parent = subsec
                    subsec.ListOfFormSectionElements.push(ele);
                });
                newSection.ListOfFormSubSections = [subsec];
                newSection.parent = programContainer;
                newSection.Dynamic = true;
                newSection.Sequence = listSection.length + 1;
                listSection.push(newSection);
            });
        });
    
        programContainer.ListOfFormSections = listSection;
       
        return programContainer;
    }

    static saveCMA = async (programContainer: ProgramContainer, status = null) => {
        if (process.env.IS_RUNTIME == 'false') return false;
        let success = false;

        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = { 'Authorization': `Bearer ${token}`}

        const api = "data/case";
        let entity = programContainer.Entity;
        
        if(!entity) return false;

        const formValue = DataUtils.collectFormValue(programContainer);
        console.log(formValue);
        if (formValue) {
            entity = {...entity ?? {}, formValue: CircularJSON.stringify(formValue)} as FormEntity;
        }
        console.log("status", status);
        if (status) {
            entity.status = status;
        } else{
            entity.status = "InProgress";
        }

        await axios.post(URLUtils.concatUrls(api), entity, {
            withCredentials: true,
            headers: headers
        }).then((response) => {
            if (response.data) {
                console.log(response.data);
                let entity = response.data;
                programContainer.Entity = entity;
                DataUtils.assignFormValue(programContainer);
            } else {
                console.error("Response does not contain 'formValue'.", response.data);
            }
            success = true;
        }).catch((error) => {
            if (error.response) {
                console.error("Server Error:", error.response.status, error.response.data);
            } else if (error.request) {
                console.error("No response received from server:", error.request);
            } else {
                console.error("Error setting up request:", error.message);
            }
        });
        return success;
    }

    static retrieveFormData = async (programContainer: ProgramContainer, status?: string) => {
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls("data/case/" + programContainer.Template +"/" + programContainer.orgId);
        if (status) {
            api += "/" + status.replace(/\s+/g, '');
        }
        const response = await axios.get((api), {
            withCredentials: true,
            headers: headers
        });

        const entity = response.data;
        programContainer.Entity = entity;
        DataUtils.assignFormValue(programContainer);
    }
}
